<template>
    <common-content-wrapper class="create-eprescribe--wrapper" width="small" :isCenter="true">
        <span class="app-track-referrals-menu">
            <common-button
                v-clickaway="physicianCloseDropdown"
                :label="$t('common.practice_type.physician')"
                type="primary"
                :size="buttonSize"
                :isClicked="isPhysicianDropdownOpen"
                @click="physicianToggleDropdown"
            ></common-button>

            <common-dropdown
                class="app-track-referrals-menu--dropdown"
                :isOpen="isPhysicianDropdownOpen"
                :hasArrow="false"
                bgColor="gray"
                arrowPositionY="top"
                arrowPositionX="left"
            >
                <common-dropdown-items :menuItems="physicianMenuItems" @item-clicked="itemClicked"></common-dropdown-items>
            </common-dropdown>
        </span>
        <span class="app-track-referrals-menu">
            <common-button
                v-clickaway="ancillaryCloseDropdown"
                :label="$t('common.practice_type.ancillary')"
                type="secondary"
                :size="buttonSize"
                :isClicked="isAncillaryDropdownOpen"
                @click="ancillaryToggleDropdown"
            ></common-button>

            <common-dropdown
                class="app-track-referrals-menu--dropdown"
                :isOpen="isAncillaryDropdownOpen"
                :hasArrow="false"
                bgColor="gray"
                arrowPositionY="top"
                arrowPositionX="left"
            >
                <common-dropdown-items :menuItems="ancillaryMenuItems" @item-clicked="itemClicked"></common-dropdown-items>
            </common-dropdown>
        </span>
    </common-content-wrapper>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ReferralTypeEnum from '@/enums/ReferralTypeEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        data() {
            return {
                isPhysicianDropdownOpen: false,
                isAncillaryDropdownOpen: false,
            }
        },

        computed: {
            physicianMenuItems() {
                return [
                    {
                        name: this.$t('common.referral_type.direct'),
                        payload: { referralType: ReferralTypeEnum.DIRECT, practiceType: PracticeTypeEnum.PHYSICIAN },
                    },
                    {
                        name: this.$t('common.referral_type.match'),
                        payload: { referralType: ReferralTypeEnum.MATCH, practiceType: PracticeTypeEnum.PHYSICIAN },
                    },
                ]
            },
            ancillaryMenuItems() {
                return [
                    {
                        name: this.$t('common.referral_type.direct'),
                        payload: { referralType: ReferralTypeEnum.DIRECT, practiceType: PracticeTypeEnum.ANCILLARY },
                    },
                    {
                        name: this.$t('common.referral_type.match'),
                        payload: { referralType: ReferralTypeEnum.MATCH, practiceType: PracticeTypeEnum.ANCILLARY },
                    },
                ]
            },

            buttonSize() {
                return !this.isMobile ? 'large' : 'small-font'
            },
        },

        methods: {
            physicianToggleDropdown() {
                this.isPhysicianDropdownOpen = !this.isPhysicianDropdownOpen
            },
            physicianCloseDropdown() {
                this.isPhysicianDropdownOpen = false
            },

            ancillaryToggleDropdown() {
                this.isAncillaryDropdownOpen = !this.isAncillaryDropdownOpen
            },
            ancillaryCloseDropdown() {
                this.isAncillaryDropdownOpen = false
            },
            itemClicked(payload) {
                this.$emit('start-e-prescribe', payload)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .create-eprescribe--wrapper {
        display: flex;
        justify-content: space-around;
        margin: 30px auto 30px auto;
    }
</style>
